import { render } from "./SceneSix.vue?vue&type=template&id=636c8a31&scoped=true"
import script from "./SceneSix.vue?vue&type=script&lang=js"
export * from "./SceneSix.vue?vue&type=script&lang=js"

import "./SceneSix.vue?vue&type=style&index=0&id=636c8a31&lang=scss&scoped=true"

import exportComponent from "/Users/danny/Documents/projects/camden-mobile/microsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636c8a31"]])

export default __exports__